import { hasGuidedProjectStart } from "./projectCapabilities";

const OPERATIONAL_LEVELS = new Set(["launchable", "operational"]);

export function getProjectExperience(project, readinessOverride = undefined) {
  const readiness = readinessOverride === undefined ? project?.readiness : readinessOverride;
  const guided = hasGuidedProjectStart(project);
  const explicitMode = String(readiness?.experience?.mode || "").trim().toLowerCase();
  const level = String(readiness?.level || "").trim().toLowerCase();

  const operational = !guided
    || explicitMode === "operational"
    || OPERATIONAL_LEVELS.has(level);

  return {
    mode: operational ? "operational" : "onboarding",
    intensiveOnboarding: Boolean(guided && !operational),
    helpAvailable: readiness?.experience?.helpAvailable !== false,
    transitionReason: readiness?.experience?.transitionReason
      || (!guided
        ? "guided_start_not_required"
        : level === "operational"
          ? "all_required_complete"
          : level === "launchable"
            ? "core_ready"
            : "guided_start_pending"),
    pendingRequiredCount: Number.isFinite(Number(readiness?.experience?.pendingRequiredCount))
      ? Math.max(0, Number(readiness.experience.pendingRequiredCount))
      : Math.max(0, Number(readiness?.requiredCount || 0) - Number(readiness?.completedCount || 0)),
  };
}

export function isIntensiveProjectOnboarding(project, readinessOverride = undefined) {
  return getProjectExperience(project, readinessOverride).intensiveOnboarding;
}
